export const MixcloudSlugSelector = ({ mixcloud }) => { console.log(mixcloud); return mixcloud } 